import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, HardHat, FileText, Receipt, ClipboardList, PhoneCall, AlertTriangle, Calendar, Wrench, Ticket, GraduationCap, Building2, Menu, X, LogOut, ChevronRight, Mail, CheckSquare } from 'lucide-react';
export function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigation = [{
    name: 'Dashboard',
    href: '/',
    icon: LayoutDashboard
  }, {
    name: 'Commerciale',
    href: '/commercial',
    icon: PhoneCall
  }, {
    name: 'Scadenze',
    href: '/deadlines',
    icon: Calendar
  }, {
    name: 'Anagrafiche clienti',
    href: '/clients',
    icon: Users
  }, {
    name: 'Lavoratori',
    href: '/workers',
    icon: HardHat
  }, {
    name: 'Offerte e contratti',
    href: '/contracts',
    icon: FileText
  }, {
    name: 'Fatturazione',
    href: '/invoicing',
    icon: Receipt
  }, {
    name: 'Attività operative',
    href: '/operations',
    icon: ClipboardList
  }, {
    name: 'Azioni',
    href: '/actions',
    icon: CheckSquare
  }, {
    name: 'Non conformità',
    href: '/non-conformities',
    icon: AlertTriangle
  }, {
    name: 'Macchinari',
    href: '/equipment',
    icon: Wrench
  }, {
    name: 'Formazione',
    href: '/training',
    icon: GraduationCap
  }, {
    name: 'Studi',
    href: '/studies',
    icon: Building2
  }, {
    name: 'Ticket',
    href: '/tickets',
    icon: Ticket
  }];
  const toggleSidebar = () => setIsOpen(!isOpen);
  return <>
      {/* Mobile menu button */}
      <div className="lg:hidden fixed top-0 left-0 z-40 p-4 w-full bg-seform-navy flex justify-between items-center shadow-md" data-id="element-975">
        <div className="flex items-center gap-3" data-id="element-976">
          <img src="https://cdn.magicpatterns.com/uploads/1KdRBrYowz6fjdh8tvZpwA/logo_sef_crm.svg" alt="SEF" className="h-10 w-auto brightness-0 invert" data-id="element-977" />
        </div>
        <button onClick={toggleSidebar} className="p-2 rounded-md text-white hover:bg-white/10 focus:outline-none" data-id="element-978">
          {isOpen ? <X className="h-6 w-6" data-id="element-979" /> : <Menu className="h-6 w-6" data-id="element-980" />}
        </button>
      </div>

      {/* Sidebar backdrop for mobile */}
      {isOpen && <div className="fixed inset-0 z-30 bg-slate-900/50 backdrop-blur-sm lg:hidden" onClick={() => setIsOpen(false)} data-id="element-981"></div>}

      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-40 w-72 text-white transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0 shadow-xl flex flex-col overflow-hidden
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `} style={{
      background: 'linear-gradient(180deg, #2D1B69 0%, #1E3A5F 100%)'
    }} data-id="element-982">
        {/* Decorative pittogramma in bottom right */}
        <div className="absolute bottom-0 right-0 w-36 pointer-events-none opacity-10" data-id="element-983">
          <img src="https://cdn.magicpatterns.com/uploads/puU4xF5g7Qr5V1qPGx34qa/icona_celeste.svg" alt="" className="w-full h-auto object-contain" aria-hidden="true" data-id="element-984" />
        </div>

        {/* Logo Area */}
        <div className="h-24 px-6 flex items-center border-b border-white/10 relative" data-id="element-985">
          <div className="flex items-center z-10" data-id="element-986">
            <img src="https://cdn.magicpatterns.com/uploads/1KdRBrYowz6fjdh8tvZpwA/logo_sef_crm.svg" alt="SEF" className="h-14 w-auto brightness-0 invert" data-id="element-987" />
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-4 py-6 space-y-1 overflow-y-auto custom-scrollbar relative z-10" data-id="element-988">
          {navigation.map(item => {
          const isActive = location.pathname === item.href;
          return <NavLink key={item.name} to={item.href} onClick={() => setIsOpen(false)} className={`
                  group flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-200 relative overflow-hidden
                  ${isActive ? 'bg-seform-orange text-white shadow-lg shadow-orange-500/20' : 'text-slate-300 hover:bg-white/10 hover:text-white'}
                `} data-id="element-989">
                <item.icon className={`mr-3 h-5 w-5 flex-shrink-0 transition-transform duration-200 ${isActive ? 'scale-110' : 'group-hover:scale-110'}`} data-id="element-990" />
                <span className="flex-1 truncate" data-id="element-991">{item.name}</span>
                {isActive && <ChevronRight className="h-4 w-4 opacity-50" data-id="element-992" />}
              </NavLink>;
        })}
        </nav>

        {/* User Profile */}
        <div className="p-4 border-t border-white/10 bg-black/20 relative z-10" data-id="element-993">
          <div className="flex items-center gap-3 p-2 rounded-xl hover:bg-white/5 transition-colors cursor-pointer group" data-id="element-994">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center text-white font-bold shadow-md" data-id="element-995">
              AL
            </div>
            <div className="flex-1 min-w-0" data-id="element-996">
              <p className="text-sm font-semibold text-white truncate" data-id="element-997">
                Alessio
              </p>
              <p className="text-xs text-slate-400 truncate" data-id="element-998">Responsabile</p>
            </div>
            <LogOut className="h-5 w-5 text-slate-400 group-hover:text-white transition-colors" data-id="element-999" />
          </div>
        </div>
      </div>
    </>;
}